export let getDateToISOString = () => new Date().toISOString();